/* eslint-disable */
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { showNotification } from "@mantine/notifications";
import { customAxios } from "lib/axios";

export interface CloseSessionPayload {
  sessionId: string;
  punchOut: string;
  notes?: string;
}

export interface CloseSessionResponse {
  success: boolean;
  data?: any;
  message?: string;
}

export const closeSessionRequest = async (
  payload: CloseSessionPayload
): Promise<CloseSessionResponse> =>
  (
    await customAxios.post<CloseSessionResponse>(
      "/attendance/close-session",
      payload
    )
  ).data;

export const useCloseSession = () => {
  const queryClient = useQueryClient();

  return useMutation<CloseSessionResponse, AxiosError, CloseSessionPayload>(
    (payload) => closeSessionRequest(payload),
    {
      onSuccess: (response) => {
        showNotification({
          title: "Session Closed",
          message: response.message || "Session closed successfully",
          color: "green",
        });

        queryClient.invalidateQueries(["unclosedSessions"]);
      },

      retry: 1,
    }
  );
};
